import { useState } from 'react';

export default function CTASection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d65digadtlshu6s4gdkg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="cta" className="py-24 px-6 bg-[#F8F6FA]">
      <div className="max-w-6xl mx-auto">
        {/* セクションタイトル */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">Order Now</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            応援<span className="text-[#8B6BAE]">購入</span>する
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            あなたの創作を支える、唯一のモバイルiPadケーススタンド
          </p>
        </div>

        {/* LINE優先案内のお知らせ */}
        <div className="max-w-2xl mx-auto mb-10">
          <div className="bg-white rounded-xl p-6 border border-[#06C755]">
            <div className="flex items-center justify-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#06C755]/10">
                <svg className="w-5 h-5 text-[#06C755]" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
                </svg>
              </div>
              <p className="text-base font-medium text-[#2C2C2C]">Makuake 公開日の優先案内</p>
            </div>
            <p className="text-2xl font-bold text-[#06C755] text-center mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              2026年3月上~中旬公開予定
            </p>
            <div className="border-t border-[#E8E8E8] pt-4">
              <p className="text-sm text-[#6B6B6B] text-center mb-3">
                販売開始時刻・早割価格を<br />LINEで誰よりも早くお届けします
              </p>
              <a
                href="https://lin.ee/d6PoCFQ6"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group flex items-center justify-center gap-2.5 w-full py-3.5 bg-[#06C755] text-white text-base font-bold rounded-full hover:bg-[#05B34C] transition-all duration-300 hover:scale-[1.02] whitespace-nowrap cursor-pointer shadow-[0_4px_20px_rgba(6,199,85,0.35)] hover:shadow-[0_6px_28px_rgba(6,199,85,0.5)]"
              >
                <svg className="w-5 h-5 flex-shrink-0 transition-transform duration-300 group-hover:scale-110" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
                </svg>
                公開日の優先案内を受取る
                <i className="ri-arrow-right-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 items-stretch">
          {/* 左側ビジュアルエリア */}
          <div className="lg:col-span-2 relative rounded-2xl overflow-hidden min-h-[480px] border border-[#E8E8E8]">
            <img
              src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/6c254c9e8133beba6384863ee86e33a8.jpeg"
              alt="Atelier Folio"
              className="w-full h-full object-cover absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C]/70 via-[#2C2C2C]/10 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full mb-3">
                <span className="text-xs tracking-widest text-white uppercase">Atelier Concept</span>
              </div>
              <h3 className="text-2xl font-bold text-white leading-tight mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                まるで持ち運べる
                <br />
                アトリエ
              </h3>
              <p className="text-sm text-white/80">
                描く人のために設計された、唯一のモバイルiPadケーススタンド
              </p>
            </div>
          </div>

          {/* 右側フォームエリア */}
          <div className="lg:col-span-3 bg-white rounded-2xl p-8 border border-[#E8E8E8]">
            <div className="mb-6">
              <h3 className="text-xl font-medium text-[#2C2C2C] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                MeVER Atelier Folio for iPad
              </h3>
              <p className="text-sm text-[#6B6B6B]">
                医学的に推奨される角度設計で、あなたの創作を支えます。
              </p>
            </div>

            {/* フォーム */}
            <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm text-[#4A4A4A] mb-1.5 font-medium">
                    お名前 <span className="text-[#E8B4B8]">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-2.5 bg-[#F8F6FA] border border-[#E8E8E8] rounded-lg focus:outline-none focus:border-[#8B6BAE] focus:bg-white transition-all text-sm"
                    placeholder="山田太郎"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm text-[#4A4A4A] mb-1.5 font-medium">
                    メールアドレス <span className="text-[#E8B4B8]">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-2.5 bg-[#F8F6FA] border border-[#E8E8E8] rounded-lg focus:outline-none focus:border-[#8B6BAE] focus:bg-white transition-all text-sm"
                    placeholder="example@email.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm text-[#4A4A4A] mb-1.5 font-medium">
                  メッセージ（任意）
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={3}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 py-2.5 bg-[#F8F6FA] border border-[#E8E8E8] rounded-lg focus:outline-none focus:border-[#8B6BAE] focus:bg-white transition-all resize-none text-sm"
                  placeholder="ご質問やご要望がありましたらお書きください"
                ></textarea>
                <p className="text-xs text-[#9B9B9B] mt-1 text-right">{formData.message.length}/500</p>
              </div>

              {submitStatus === 'success' && (
                <div className="p-3 bg-[#E8F5E9] border border-[#A5D6A7] rounded-lg flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg"></i>
                  <p className="text-sm text-[#2E7D32]">送信が完了しました。ありがとうございます！</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-3 bg-[#FFEBEE] border border-[#EF9A9A] rounded-lg flex items-center gap-2">
                  <i className="ri-error-warning-fill text-[#EF5350] text-lg"></i>
                  <p className="text-sm text-[#C62828]">送信に失敗しました。もう一度お試しください。</p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-3.5 bg-[#8B6BAE] text-white text-base font-medium rounded-full hover:bg-[#7A5C9E] transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 group"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-lg"></i>
                    送信中...
                  </>
                ) : (
                  <>
                    応援購入する
                    <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
